'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

const CommonGallery = require('components/CommonGallery/CommonGallery');

module.exports = Backbone.View.extend({

    initialize: function () {
        _.bindAll(this, 'onBodyClick');
    },


    initGalleries: function () {
        if (this.isGalleriesInitialized) {
            return;
        }

        this.galleries = {};
        this.$('.CommonGallery').each(function (index, item) {
            var id = $(item).attr('data-id') - 0;
            this.galleries[id] = new CommonGallery({
                el: item
            });
        }.bind(this));

        this.isGalleriesInitialized = true;
    },

    onInnerLinkClick: function (e) {
        var id = $(e.currentTarget).attr('data-id') - 0;

        this.showGallery(id);
    },

    onGalleryShow: function () {

    },

    onGalleryHide: function () {

    },


    closePrevious: function (params) {
        if (this.prevShownId !== undefined) {
            if (params.ask) {
                if (this.galleries[this.prevShownId].hasOpenedItems()) {
                    return;
                }
            }
            this.galleries[this.prevShownId].hide();

            this.onGalleryHide(this.prevShownId);
        }

        $('body').off('click', this.onBodyClick);

        delete this.prevShownId;
    },


    showGallery: function (id) {
        this.initGalleries();

        if (!this.galleries[id]) {
            return;
        }

        if (id === this.prevShownId) {
            return;
        }

        this.closePrevious({
            ask: false
        });

        setTimeout(function () {
            $('body').on('click', this.onBodyClick);
        }.bind(this), 50);

        this.galleries[id].show();

        this.onGalleryShow(id);

        if (!app.settings.isPhone) {
            this.prevShownId = id;
        }
    },


    onBodyClick: function (e) {
        if (app.settings.isPhone) {
            return;
        }

        if ($(e.target).closest('.CommonGallery-item').length) {
            return;
        }

        if ($(e.target).closest('span[data-id]').length) {
            return;
        }

        if ($(e.target).closest('a').length) {
            return;
        }

        this.closePrevious({
            ask: true
        });
    }
});
